import React, { useContext } from 'react';
// room context
import { RoomContext } from '../context/RoomContext';
// headless ui menu
import { Menu } from '@headlessui/react';
// icons
import { BsChevronDown } from 'react-icons/bs';
// import translation hook
import { useTranslation } from 'react-i18next';

const KidsDropdown = () => {
  const { t } = useTranslation();
  const { kids, setKids } = useContext(RoomContext);

  const lis = [0, 1, 2, 3, 4];

  return (
    <Menu as='div' className='w-full h-full bg-white relative'>
      {/* btn */}
      <Menu.Button className='w-full h-full flex items-center justify-between px-8'>
        {t(kids === 0 ? 'Dziecko_0' : kids === 1 ? 'Dziecko_1' : 'Dziecko_other', { count: kids })}
        <BsChevronDown className='text-base text-accent-hover' />
      </Menu.Button>
      {/* items */}
      <Menu.Items
        as='ul'
        className='bg-white absolute w-full flex flex-col z-40'
      >
        {lis.map((count, index) => (
          <Menu.Item
            onClick={() => setKids(count)}
            as='li'
            className='border-b last-of-type:border-b-0 h-12 hover:bg-accent hover:text-white w-full flex justify-center items-center cursor-pointer'
            key={index}
          >
            {t(count === 0 ? 'Dziecko_0' : count === 1 ? 'Dziecko_1' : 'Dziecko_other', { count })}
          </Menu.Item>
        ))}
      </Menu.Items>
    </Menu>
  );
};

export default KidsDropdown;
